import PropTypes from 'prop-types';
import { css } from '@eti/styles';
import { BoundNew } from '@eti/types';
import { transformToCartFlightInfoItems } from './utils/bounds';

const flightInfoStyles = css`
  font-size: 0.75rem;
  margin-top: 0.5rem;
`;

const airportCodeStyles = css`
  font-weight: 700;
`;

const cartFlightInfoItemsWithIds = (bounds) =>
  transformToCartFlightInfoItems(bounds).map((flightInfo, index) => {
    return { ...flightInfo, id: index };
  });

const ReceiptFlightInformation = ({ bounds = [], viewMode = '' }) => {
  return (
    <div data-testid={`cart-content-Trips${viewMode}`}>
      {cartFlightInfoItemsWithIds(bounds).map((flightInfo) => {
        const { destination, origin, id } = flightInfo;
        return (
          <div
            className={flightInfoStyles}
            data-testid={`cart-content-Trip${viewMode}`}
            key={`flight-info_${origin.code}-${destination.code}-${id}`}
          >
            <div>
              <span className={airportCodeStyles}>{origin.code}</span> {origin.cityName},
              {origin.name}
            </div>
            <div>
              <span className={airportCodeStyles}>{destination.code}</span> {destination.cityName},{' '}
              {destination.name}
            </div>
          </div>
        );
      })}
    </div>
  );
};

ReceiptFlightInformation.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
  viewMode: PropTypes.string,
};

export default ReceiptFlightInformation;
